// src/services/thunks/downloadMetricsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getDownloadMetrics = createAsyncThunk(
  "downloadMetrics/getAll",
  async (
    { sort = "last3Hours", offset = 0, limit = 10 } = {},
    { rejectWithValue },
  ) => {
    try {
      // DataTable passes offset/limit — convert to page for this API
      const page = Math.floor(offset / limit) + 1;

      const response = await api.get("/monitoring/download-metrics", {
        params: { sort, page, limit },
      });

      // Response: { status, data: { data: [...users], meta: { total, page, limit, totalPages } } }
      const inner = response.data?.data || {};
      const items = Array.isArray(inner.data) ? inner.data : [];
      const meta = inner.meta || {};

      // Transform into the shape DataTable expects:
      //   result.response?.data?.items
      //   result.response?.data?.pagination?.totalDocuments
      return {
        data: {
          items,
          pagination: {
            totalDocuments: Number(meta.total) || 0,
            totalPages: Number(meta.totalPages) || 1,
            page: Number(meta.page) || 1,
            limit: Number(meta.limit) || limit,
          },
        },
      };
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch download metrics";
      return rejectWithValue({ message, code: err?.response?.status || 500 });
    }
  },
);
